import { TreeViewNode } from '../../../models/primitive/tree-view-node';
import { TextModel } from '../../../models/primitive/text.model';
import { ODataModel } from '../../../interfaces/odata-model.interface';

let nodeId = 1;

function fixParents<T extends ODataModel>(rootNode: TreeViewNode<T>): TreeViewNode<T> {
    let nodesToCheck: Array<TreeViewNode<T>> = [];
    nodesToCheck.push(rootNode);
    while (nodesToCheck.length > 0) {
        const currentNode = nodesToCheck.shift();

        if (currentNode) {
            currentNode.children.forEach((child) => (child.parent = currentNode));
            nodesToCheck = nodesToCheck.concat(currentNode.children);
        }
    }

    return rootNode;
}

function createChildNode(id: number): TreeViewNode<TextModel> {
    return new TreeViewNode<TextModel>(id, `Child ${id}`, new TextModel(`childNode${id}`, `ChildNode${id}`));
}
export function createTreeViewData(): TreeViewNode<TextModel> {
    const rootNode = new TreeViewNode<TextModel>(nodeId++, 'Root node', new TextModel('RootNode', 'rootNode'));
    const firstFirstLevelChild = createChildNode(nodeId++);
    const secondFirstLevelChild = createChildNode(nodeId++);
    const thirdFirstLevelChild = createChildNode(nodeId++);
    const firstSecondLevelChild = createChildNode(nodeId++);
    const secondSecondLevelChild = createChildNode(nodeId++);
    const thirdSecondLevelChild = createChildNode(nodeId++);
    const firstThirdLevelChild = createChildNode(nodeId++);
    const secondThirdLevelChild = createChildNode(nodeId++);

    rootNode.children.push(firstFirstLevelChild);
    rootNode.children.push(secondFirstLevelChild);
    rootNode.children.push(thirdFirstLevelChild);
    thirdFirstLevelChild.children.push(firstSecondLevelChild);
    thirdFirstLevelChild.children.push(secondSecondLevelChild);
    thirdFirstLevelChild.children.push(thirdSecondLevelChild);
    secondSecondLevelChild.children.push(firstThirdLevelChild);
    secondSecondLevelChild.children.push(secondThirdLevelChild);

    return fixParents(rootNode);
}
